import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setHeaderTitle } from '../redux/slices/layoutSlice';
import {
  battleshipModalOpenSelector,
  challengedSelector,
  challengeModalOpenSelector,
  connectFourModalOpenSelector,
  ticTacToeModalOpenSelector,
} from '../redux/slices/gameParrotSlice';

/**
 * Custom hook for managing the game parrot game state.
 *
 * @returns challengeModalOpen - Whether the challenge modal is open
 * @returns challenged - The user being challenged.
 * @returns setChallenged - A function to set the challenged user.
 * @returns ticTacToeModalOpen - Whether the tic tac toe modal is open.
 * @returns connectFourModalOpen - Whether the connect four modal is open.
 * @returns battleshipModalOpen - Whether the battleship modal is open.
 */
const useGameParrot = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const challenged = useAppSelector(challengedSelector);
  const challengeModalOpen = useAppSelector(challengeModalOpenSelector);
  const ticTacToeModalOpen = useAppSelector(ticTacToeModalOpenSelector);
  const connectFourModalOpen = useAppSelector(connectFourModalOpenSelector);
  const battleshipModalOpen = useAppSelector(battleshipModalOpenSelector);

  useEffect(() => {
    if (location.pathname === '/home') {
      dispatch(setHeaderTitle('Explore'));
    }
  }, [dispatch, location]);

  return {
    challengeModalOpen,
    challenged,
    ticTacToeModalOpen,
    connectFourModalOpen,
    battleshipModalOpen,
  };
};

export default useGameParrot;
